import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import filterIcon from '../../../../images/subcategories/filter-action.svg';
import { SubcategoriesAction } from '../SubcategoriesAction';
import { SubcategoriesFilterActionDialog } from '../SubcategoriesFilterActionDialog';

export const SubcategoriesFilterAction = ({
    onToggle,
    opened = false,
    currentSubcategory,
}) => {
    const { filterBy } = useSelector(state => state.app.subcategoriesActions);
    const filteredByProviders = filterBy.providers?.length > 0;
    const handleDialogClose = useCallback(() => onToggle(false), [onToggle]);

    return <SubcategoriesAction className="asg-subcategories__actions-item--filtering"
        onToggle={onToggle}
        opened={opened}
        iconImage={filterIcon}
        isIconActive={filteredByProviders}
        labelTranslationKey="filters"
    >
        <SubcategoriesFilterActionDialog
            show={opened}
            onClose={handleDialogClose}
            currentSubcategory={currentSubcategory}
        />
    </SubcategoriesAction>;
};
